import { hudBar } from './hud.js';
import { uiFormat } from './text.js';

/**
 * How many players are in the world, first in the top HUD row, left of the
 * home button. The count is the server's (`ZoneState.online`); the scene
 * hands it over every frame and the DOM is only touched when it changes.
 */
export class OnlineCount {
  private readonly root: HTMLElement;
  private shown = -1;

  private readonly label: HTMLElement;
  private readonly number: HTMLElement;

  constructor() {
    this.root = document.createElement('div');
    this.root.className = 'hud-button hud-online';
    this.root.setAttribute('role', 'status');
    // A narrow window shows the number alone (the row would run over the
    // place's name, top left); the sentence stays in the tooltip.
    this.label = document.createElement('span');
    this.label.className = 'hud-online__label';
    this.number = document.createElement('span');
    this.number.className = 'hud-online__count';
    this.number.setAttribute('aria-hidden', 'true');
    this.root.append(this.label, this.number);
    hudBar('top').prepend(this.root);
  }

  set(count: number): void {
    if (count === this.shown) return;
    this.shown = count;
    const template = count > 1 ? '{count} joueurs en ligne' : '{count} joueur en ligne';
    const sentence = uiFormat(template, { count });
    this.label.textContent = sentence;
    this.number.textContent = String(count);
    this.root.title = sentence;
  }

  destroy(): void {
    this.root.remove();
  }
}
